import React from 'react'
import { withIcon } from '../../withIcon'

function ArrowRightIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.5581 5.55806C12.8021 5.31398 13.1979 5.31398 13.4419 5.55806L19.4419 11.5581C19.686 11.8021 19.686 12.1979 19.4419 12.4419L13.4419 18.4419C13.1979 18.686 12.8021 18.686 12.5581 18.4419C12.314 18.1979 12.314 17.8021 12.5581 17.5581L17.4911 12.625H5C4.65482 12.625 4.375 12.3452 4.375 12C4.375 11.6548 4.65482 11.375 5 11.375H17.4911L12.5581 6.44194C12.314 6.19786 12.314 5.80214 12.5581 5.55806Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ArrowRightIcon)
